module.exports = __webpack_public_path__ + "static/knecht-c95327aa9aba4e31dce14dba1ee88290.svg";